import { createFileRoute } from "@tanstack/react-router";

import { CompaniesListPage } from "@/features/companies/list";

export const Route = createFileRoute("/_authenticated/companies/")({
  component: () => <CompaniesListPage />,
});
